// src/services/api.js
import axios from "axios";

const BASE_URL = "https://familymart-343666073191.us-central1.run.app/api";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// INTERCEPTOR TO HANDLE GUEST/USER TOKEN
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  const isGuest = localStorage.getItem("isGuest") === "true";

  if (token) {
    if (isGuest) {
      config.headers["x-guest-token"] = token;
      delete config.headers["Authorization"];
    } else {
      config.headers["Authorization"] = `Bearer ${token}`;
      delete config.headers["x-guest-token"];
    }
  }

  return config;
}, (error) => Promise.reject(error));

// RESPONSE INTERCEPTOR — gracefully handle an expired/invalid session.
// When a logged-in user's JWT expires the backend returns 401 ("Invalid or
// expired token") on every protected call. Without this, the user is stranded
// seeing that raw error. Here we end the dead session and send them to login
// with a friendly notice. Guests are left to each page's own "please login"
// prompts (a guest token is just an identifier and never expires).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    // Never act on the auth endpoints themselves — e.g. a wrong-password 401
    // on /users/login must surface on the form, not trigger a redirect.
    const isAuthEndpoint = /login|register|forgot-password|reset-password|guest-token/i.test(url);

    const wasLoggedIn =
      localStorage.getItem("isGuest") !== "true" && !!localStorage.getItem("authToken");

    if (status === 401 && !isAuthEndpoint && wasLoggedIn) {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("authToken");
      localStorage.removeItem("isGuest");

      // Redirect once; the guard avoids loops when already on the login page.
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign("/login?session=expired");
      }
    }

    return Promise.reject(error);
  }
);

export default api;
